import { EcoImage } from '@components/shared';
import { PUBLIC_IMG_URL } from '@utils/constants/config';
import React from 'react';

interface Props {}

export default function EcoLogo({}: Props): JSX.Element {
  return <EcoImage resizeMode="contain" width={150} height={30} src={PUBLIC_IMG_URL + '/ecocart-logo.svg'} />;
}
